import { v4 as uuid } from "uuid";

export const quizData=[
    {
        id:"222b9b66-4a8f-4988-958a-3b7f9b8f983a",
        image:"https://res.cloudinary.com/doohtm4bs/image/upload/v1652512639/Quiz%20App/odi_jrsqzk.png",
        category:"ODI cricket",
        questions:[
        {
            question:"Highest run scorer in ODI men's cricket?",
            points:10,
            options:[
                {
                    value:"KS Sangakara",
                    isRight:false
                },
                {
                    value:"Sachin Tendulkar",
                    isRight:true
                },
                {
                    value:"Ricky Ponting",
                    isRight:false
                },
                {
                    value:"ST Jayasuriya",
                    isRight:false
                }
            ]
        },
        {
            question:"Who is the highest wicket-taker at men's ODI World Cups?",
            points:10,
            options:[
                {
                    value:"Wasim Akram",
                    isRight:false
                },
                {
                    value:"Mutthiah Murlithran",
                    isRight:false
                },
                {
                    value:"Glen McGrath",
                    isRight:true
                },
                {
                    value:"Lasith Malinga",
                    isRight:false
                }
            ]
        },
        {
            question:"Who is the only Indian bowler to have taken two hat-tricks in men’s ODIs?",
            points:10,
            options:[
                {
                    value:"Kapil Dev",
                    isRight:false
                },
                {
                    value:"Kuldeep Yadav",
                    isRight:true
                },
                {
                    value:"Chetan Sharma",
                    isRight:false
                },
                {
                    value:"Mohammed Shami",
                    isRight:false
                }
            ]
        },
        {
            question:"Who has scored the fastest ODI hundred by an Indian?",
            points:10,
            options:[
                {
                    value:"Yuvraj Singh",
                    isRight:false
                },
                {
                    value:"Rishabh Pant",
                    isRight:false
                },
                {
                    value:"Virendra Sehwag",
                    isRight:false
                },
                {
                    value:"Virat Kohli",
                    isRight:true
                }
            ]
        },
        {
            question:"Who was named the ICC Men's ODI Cricketer of the Year for 2021?",
            points:10,
            options:[
                {
                    value:"Virat Kohli",
                    isRight:false
                },
                {
                    value:"Jos Butler",
                    isRight:false
                },
                {
                    value:"Babar Azam",
                    isRight:true
                },
                {
                    value:"Steve Smith",
                    isRight:false
                }
            ]
        }
    ]

    },

    {
        id:"7f2872df-9b07-4953-bcfe-aa45bd9d7751",
        image:"https://res.cloudinary.com/doohtm4bs/image/upload/v1652512636/Quiz%20App/test_jfruru.jpg",
        category:"Test cricket",
        questions:[
            {
                question:"Who has the record of most double centuries in Test cricket?",
                points:10,
                options:[
                    {
                        value:"Sachin Tendulkar",
                        isRight:false
                    },
                    {
                        value:"Ricky Ponting",
                        isRight:false
                    },
                    {
                        value:"Virat Kohli",
                        isRight:false
                    },
                    {
                        value:"Don Bradman",
                        isRight:true
                    }
                ]
            },
            {
                question:"Who won the World Test Championship final 2021?",
                points:10,
                options:[
                    {
                        value:"England",
                        isRight:false
                    },
                    {
                        value:"New Zealand",
                        isRight:true
                    },
                    {
                        value:"Australia",
                        isRight:false
                    },
                    {
                        value:"South Africa",
                        isRight:false
                    }
                ]
            },
            {
                question:"Maximum limit of overs on each day of Test cricket?",
                points:10,
                options:[
                    {
                        value:"75",
                        isRight:false
                    },
                    {
                        value:"80",
                        isRight:false
                    },
                    {
                        value:"90",
                        isRight:true
                    },
                    {
                        value:"85",
                        isRight:false
                    }
                ]
            },
            {
                question:"What is the highest score in a test innings?",
                points:10,
                options:[
                    {
                        value:"864",
                        isRight:false
                    },
                    {
                        value:"918",
                        isRight:false
                    },
                    {
                        value:"952",
                        isRight:true
                    },
                    {
                        value:"794",
                        isRight:false
                    }
                ]
            },
            {
                question:"What is the highest individual score in an innings in a test match and who holds that record??",
                points:10,
                options:[
                    {
                        value:"400,Brian Lara",
                        isRight:true
                    },
                    {
                        value:"319, Virendra Sehwag",
                        isRight:false
                    },
                    {
                        value:"380, Matthew Hayden",
                        isRight:false
                    },
                    {
                        value:"305, Karun Nair",
                        isRight:false
                    }
                ]
            }
        ]
    }
];